<template>
	<div class="skyWeektime">
		<drag-weektime v-model="selfValue" :colspan="colspan" @change="change" />
	</div>
</template>
<script>
import DragWeektime from './dragWeektime/dragWeektime.vue';
export default {
	name: 'skyWeektime',
	props: {
		value: {
			type: String,
			default: ''
		},
		colspan: {
			type: Number,
			default: 2
		}
	},
	data(){
		return {
			selfValue:''
		}
	},
	watch: {
		value:{
			handler(val){
				this.selfValue = val
			},
			immediate: true
		}
	},
	components: {
		DragWeektime
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		}
	}
};
</script>
